/**
 * @description : Data Loader
 * @author : SAR TECH EASY
 * @date : 21-04-2023
 * */

/* Import Components and Functions Here */
import React from 'react';
import { Spinner } from 'react-bootstrap';
import styles from './DataLoader.module.scss';

function DataLoader(props) {
  const { noData, textColor, spinnerVariant = 'primary' } = props;

  const containerStyle = {
    '--loader-text-color': textColor,
  };

  return (
    <>
      <div className={styles.dataLoaderBlock} style={containerStyle}>
        {noData ? (
          <h5>No Data Available</h5>
        ) : (
          <>
            {' '}
            <Spinner
              className="ms-2"
              animation="border"
              variant={spinnerVariant}
            />
            <h5>Loading Data...</h5>
          </>
        )}
      </div>
    </>
  );
}

export default DataLoader;
